import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/components/Home'
// import Blog from '@/components/Blog'
const Home = () => import('@/components/Home')
const Blog = () => import('@/components/Blog')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [  
  {
    path: '*',
    redirect: '/home/main'
  }, 
  {
    path: '/',
    redirect: '/home/main'
  },
  {
    path: '/home/:target',
    name: 'Home',
    component: Home,
    props: true
  },
  {
    path: '/blog',
    name: 'feed',
    component: Blog
  }, {
    path: '/by/:author',
    name: 'author',
    props: true,
    component: Blog
  }, {
    path: '/read/:post',
    name: 'post',
    props: true,
    component: Blog
  }]
})
